import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=71c9a019&"
import script from "./Item.vue?vue&type=script&lang=js&"
export * from "./Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp7.4.1\\htdocs\\e2e-invoicing\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71c9a019')) {
      api.createRecord('71c9a019', component.options)
    } else {
      api.reload('71c9a019', component.options)
    }
    module.hot.accept("./Item.vue?vue&type=template&id=71c9a019&", function () {
      api.rerender('71c9a019', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/invoices/Item.vue"
export default component.exports